import { TextFormatAttribute } from './select-event-attribute';

export class SelectEvent {
  text: string;
  startPos: number; /* selection start position in the document */
  endPos: number; /* selection end position ofin the document */
  textFormatAttributes: TextFormatAttribute[];
  nodeAttrs: any; /* attributes of the selected node. If are selected two or more nodes the object will be empty */
  nodeMarks: any; /* marks of the selected node. If are selected two or more nodes the object will be empty  */
  isList: any; // ordered|unordered|false
}

